





































import { SumInputVue } from "fs-pb-vue2/vueModels/app/SumInputVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class SumInput extends SumInputVue {
  /** при создании присваеваем внешнее значние v-model внутреннему */
  created() {
    this.SumValue = this.value?.toString();
    if (this.rules !== undefined && this.rules !== null)
      this.defRules = this.rules;
    this.tryFormat();
  }
}
